import { ReducedContentPageType } from '@xing-com/crate-common-graphql-types';

export enum RecommendationPageType {
  INDUSTRY = 'industry_pages',
  INSIDER = 'insider_pages',
  PREMIUM = 'news_plus_pages',
  PRESS_REVIEW = 'pressespiegel',
  PUBLISHER = 'publisher_pages',
  TOPIC = 'topic_pages',
}

export const contentPageTypeMap: Record<
  RecommendationPageType,
  ReducedContentPageType
> = {
  [RecommendationPageType.INDUSTRY]: ReducedContentPageType.Industry,
  [RecommendationPageType.INSIDER]: ReducedContentPageType.Insider,
  [RecommendationPageType.PREMIUM]: ReducedContentPageType.Premium,
  [RecommendationPageType.PRESS_REVIEW]: ReducedContentPageType.PressReview,
  [RecommendationPageType.PUBLISHER]: ReducedContentPageType.Publisher,
  [RecommendationPageType.TOPIC]: ReducedContentPageType.Topic,
};

export const recommendationPageToTrackingPageMap: Record<
  RecommendationPageType,
  string
> = {
  [RecommendationPageType.INDUSTRY]: 'industries',
  [RecommendationPageType.INSIDER]: 'insiders',
  [RecommendationPageType.PREMIUM]: 'newsplus',
  [RecommendationPageType.PRESS_REVIEW]: 'press_review',
  [RecommendationPageType.PUBLISHER]: 'publishers',
  [RecommendationPageType.TOPIC]: 'topics',
};

export const recommendationPagesWithNewsletter: RecommendationPageType[] = [
  RecommendationPageType.INDUSTRY,
  RecommendationPageType.TOPIC,
  RecommendationPageType.PRESS_REVIEW,
];
